module.exports = __webpack_public_path__ + "img/avatar2.8dc2de9f.png";